export const membershiptransaction = [
  {
    id: 1,
    si_no: "",
    select: "",
    type: "Wallet Topup",
    amount: "+$650",
    date: "25 Sep 2023, 01:22 pm",
    payment_type: "Paypal",
    status: "Completed",
    key: "1"
  },
  {
    id: 2,
    si_no: "",
    select: "",
    type: "Purchase",
    amount: "-350",
    date: "27 Sep 2023, 04:18 pm",
    payment_type: "Cash",
    status: "Cancel",
    key: "2"
  },
  {
    id: 3,
    si_no: "",
    select: "",
    type: "Refund",
    amount: "+$100",
    date: "29 Sep 2023, 10:08 am",
    payment_type: "Paypal",
    status: "Completed",
    key: "3"
  },
  {
    id: 4,
    si_no: "",
    select: "",
    type: "Wallet Topup",
    amount: "+$650",
    date: "05 Oct 2023, 09:43 am",
    payment_type: "Cash",
    status: "Completed",
    key: "4"
  },
  {
    id: 5,
    si_no: "",
    select: "",
    type: "Wallet Topup",
    amount: "+$650",
    date: "17 Oct 2023, 01:22 am",
    payment_type: "Paypal",
    status: "Cancel",
    key: "5"
  },
  {
    id: 6,
    si_no: "",
    select: "",
    type: "Wallet Topup",
    amount: "+$650",
    date: "22 Oct 2023, 06:32 pm",
    payment_type: "Cash",
    status: "Completed",
    key: "6"
  },
];
